import { titleCase } from 'title-case';

export const decodeSlug = (slug: string) => {
  return titleCase(slug.replace(/-/g, ' '));
};

export const encodeSlug = (slug: string) => slug.replace(/ /g, '-').toLowerCase();
